import Schema from './Schema';

export {
  SchemaModel,
  StringType,
  NumberType,
  ArrayType,
  DateType,
  ObjectType,
  BooleanType,
  MixedType
} from 'schema-typed';
export { Schema };
export default Schema;
